import Hostaway from "../../../images/logos/Hostaway.svg";
import Shopify from "../../../images/logos/Shopify.svg";
import Guesty from "../../../images/logos/Guesty.svg";
import Equifax from "../../../images/logos/Equifax.svg";
import Thomson_Reuters from "../../../images/logos/Thomson_Reuters.svg";
import TransUnion from "../../../images/logos/TransUnion.svg";
import aws from "../../../images/logos/aws.svg";
import Twilio from "../../../images/logos/Twilio.svg";
import DataDog from "../../../images/logos/DataDog.svg";
import CIC from "../../../images/logos/CIC.svg";
import FullContact from "../../../images/logos/Full_Contact.svg";
import Idpro from "../../../images/logos/IDpro.png";
import Aicpa from "../../../images/logos/AICPA.png";
import Pbsa from "../../../images/logos/PBSA.svg";
import HIPPA from "../../../images/logos/HIPPA.svg";
import PCI from "../../../images/logos/PCI.svg";
import NIST from "../../../images/logos/NIST.svg";

export const vendorLogosList = [
	{
		id: 0,
		name: "Hostaway",
		link: "https://www.hostaway.com/marketplace/authenticating-com/",
		logo: Hostaway
	},
	{
		id: 1,
		name: "Shopify",
		link: "https://apps.shopify.com/authenticating",
		logo: Shopify
	},
	{
		id: 2,
		name: "Guesty",
		link: "https://www.guesty.com/marketplace-items/authenticating-com/",
		logo: Guesty
	},
	{ id: 3, name: "Equifax", link: "https://www.equifax.com/", logo: Equifax },
	{
		id: 4,
		name: "Thomson Reuters",
		link: "https://www.thomsonreuters.com/en.html",
		logo: Thomson_Reuters
	},
	{ id: 5, name: "AWS", link: "https://aws.amazon.com/", logo: aws },
	{
		id: 6,
		name: "TransUnion",
		link: "https://www.transunion.com/",
		logo: TransUnion
	},
	{ id: 7, name: "Twilio", link: "https://www.twilio.com/", logo: Twilio },
	{
		id: 8,
		name: "DataDog",
		link: "https://www.datadoghq.com/",
		logo: DataDog
	},
	{ id: 9, name: "CIC", link: "https://www.cicreports.com/", logo: CIC },
	{
		id: 10,
		name: "Full Contact",
		link: "https://www.fullcontact.com/",
		logo: FullContact
	}
];

export const freeVerifications = [
	{
		id: 1,
		title: "Email Verification",
		toolTipNote:
			"Verify an email address with a time-sensitive, six digit passcode that is sent to the user.",
		price: "$0",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1user~1verifyEmail/post",
		required: false
	},
	{
		id: 2,
		title: "Phone Number Verification",
		toolTipNote:
			"Verify a mobile phone number worldwide with a time-sensitive, six digit passcode that is sent to the user.",
		price: "$0",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1user~1verifyPhone/post",
		required: false
	},
	{
		id: 3,
		title: "Facial Recognition & Liveness Detection",
		toolTipNote:
			"Verify the likeness of a face in two images by comparing photos & receiving an instant correlation score. The comparison photo will also be measured for liveness using iBeta Level 2 anti-spoofing technology.",
		price: "$0",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1user~1comparePhotos/post",
		required: true
	},
	{
		id: 4,
		title: "Authoritative Database Search",
		toolTipNote:
			"Verify the user’s data with authoritative databases in 40 countries worldwide.",
		price: "$0",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1document~1scan~1data/post",
		required: true
	},
	{
		id: 5,
		title: "US Criminal Database Search",
		toolTipNote:
			"Generate a TRUE or FALSE response if any records may be available for the user in sex offender registries or criminal records databases from all 50 US states. This search may also include digitized records from Department of Corrections, Administrative Office of the Courts & county courts. Coverage varies by state.",
		price: "$0",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1user~1generateCriminalReport/post",
		required: true
	},
	{
		id: 6,
		title: "Global Watchlist Search",
		toolTipNote:
			"Generate a TRUE or FALSE verification response if there appear to be any global watch list records matching the proven identity by at least 65%. This search includes 60+ sanctions & watch lists, including OFAC (SDNs & other lists), EU Consolidated List, HM Treasury Sanctions, UN Consolidated List, FBI Most Wanted & more.",
		price: "$0",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1request~1watchlist~1global/post",
		required: true
	},
	{
		id: 7,
		title: "Score Inputs",
		toolTipNote:
			"Score Inputs tell you whether or not the input data on a specific user matches the data we have in our proprietary identity graph—and offers a risk score based on the match (or lack thereof).",
		price: "$0",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1risk~1match/post",
		required: false
	}
];

export const instantVerifications = [
	{
		id: 1,
		title: "Government ID Verification",
		toolTipNote:
			"Verify a two sided ID with a photo of the front of the document which is read with OCR & a photo of the back of the document where the barcode is decoded & matched with the data from the front with all the information on the document returned along with our degree of confidence that it's authentic.",
		price: "$1",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1document~1scan/post",
		required: false
	},
	{
		id: 2,
		title: "Knowledge Based Authentication",
		toolTipNote:
			"Verify & authenticate identity with a personal knowledge quiz generated from the user's name & date of birth & some, none or all of the SSN.",
		price: "$1",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1kba/post",
		required: false
	},
	{
		id: 3,
		title: "SSN Verification",
		toolTipNote: "Verify a person’s SSN",
		price: "$1",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1user~1verify~1ssn/post",
		required: false
	},
	{
		id: 4,
		title: "FEIN, Tax ID & DUNS® Verification",
		toolTipNote:
			"Verify an entity’s name, FEIN, Tax ID & DUNS Number and if the user is a business contact or not",
		price: "$1",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1business~1verification/post",
		required: false
	},
	{
		id: 5,
		title: "Global Watch List Report",
		toolTipNote:
			"Verify Global Watch List data which covers 60+ sanctions & watch lists, including OFAC (SDNs & other lists), EU Consolidated List, HM Treasury Sanctions, UN Consolidated List, FBI Most Wanted & more matching the proven identity by at least 65% are provided.",
		price: "$1",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1request~1watchlist~1global~1report/post",
		required: false
	},
	{
		id: 6,
		title: "Verify Inputs",
		toolTipNote:
			"Verify Inputs provides you with actual input data insights into how confident we are about the given person’s identity, inputs, and risk level. Verify Inputs are highly specific and provide high-value information.",
		price: "$1",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1risk~1inputs/post",
		required: false
	}
];

export const enhancedVerifications = [
	{
		id: 1,
		title: "Enhanced Government ID Verification",
		toolTipNote:
			"Authenticate any government issued ID with 50 forensic tests to return an instant authentication result & a data payload of all the information on the ID. Covers over 6,000 government issued IDs from more than 200 countries & 38 languages. Includes automatic fallback, expert manual review.",
		price: "$2",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1document~1scan~1enhanced/post",
		required: false
	},
	{
		id: 8,
		title: "True Continuous Monitoring™ ",
		toolTipNote:
			"Provides alerts in near-real time about new criminal activity that could indicate threats to your business. The fee is for a one-year enrolment which renews annually on the anniversary of enrolment if the person is not removed from the watch list first.",
		price: "$2",
		link: "https://drive.google.com/file/d/1P1q-T9IUkaxjTh54WhGzG1gwBySjzvR8/view",
		required: false
	},
	{
		id: 2,
		title: "Current or Past US Employment Verification",
		toolTipNote:
			"Verify Employer Name, Town, State & Country, Job Title, Date Employed From & To, Supervisor Name, if they are currently employed & what their contract type is. No passthrough fees. If unavailable by database the average turnaround time is 48 hours to get a response from the source.",
		price: "$5",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1employment~1verify/post",
		required: false
	},
	{
		id: 3,
		title: "US College & University Verification",
		toolTipNote:
			"Verify School Name & Type, Campus Name, School Town & Country, Start Date & End Date, Degree Title, if they are currently attending and/or if they've completed their degree successfully. No passthrough fees.",
		price: "$5",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1education~1verify/post",
		required: false
	},
	{
		id: 4,
		title: "US Professional License Verification",
		toolTipNote:
			"Verify License Title, Organization & Number, State & End Date, State & Country. If unavailable by database the average turnaround time is 48 hours to get a response from the source.",
		price: "$5",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1professional~1license/post",
		required: false
	},
	{
		id: 5,
		title: "DMV & MVR Verification",
		toolTipNote:
			"Verify Motor Vehicle Records from DMVs in all 50 states. MVRs include license details such as state issued, status, expiration, suspensions, revocations, violations & sanctions. Additional DMV fees vary by state.",
		price: "$5",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1mvr/post",
		required: false
	},
	{
		id: 6,
		title: "Full US Business Verification ",
		toolTipNote:
			"Verify the Date of Incorporation, Address, Business Name(s), Status & Corporation Type.",
		price: "$5",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1business~1verification~1comprehensive/post",
		required: false
	},
	{
		id: 7,
		title: "7 Year Criminal Activity Verification",
		toolTipNote:
			"Verify any commercially available criminal activity data that can be found nationwide for the last seven years. No pass through fees & an instant turnaround.",
		price: "$5",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1identity~1request~1criminal~1report~1seven/post",
		required: false
	},

	{
		id: 9,
		title: "County Criminal & Civil Record Verification",
		toolTipNote: "Verify any county-level criminal and/or civil records.",
		price: "$5+",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1user~1verify~1criminal~1county/post",
		required: true,
		doubleStar: true
	},
	{
		id: 10,
		title: "Federal Criminal & Civil Record Verification",
		toolTipNote:
			"Verify any federal criminal and/or federal civil records. Our researchers will seek all publicly available records by default.",
		price: "$5+",
		link: "https://docs.authenticating.com/#tag/Methods/paths/~1user~1verify~1criminal~1federal/post",
		required: true,
		doubleStar: true
	}
];

export const footerLogos = [
	{
		id: 0,
		name: "NIST",
		link: "https://pages.nist.gov/800-63-3/sp800-63-3.html",
		tooltipText:
			"Authenticate strives to maintain the highest security standards, are in process of obtaining a military grade opinion letter.",
		logo: NIST
	},
	{
		id: 1,
		name: "AICPA",
		link: "https://cdn.authenticating.com/public/website/Authenticating.com_Audit_Confirmation_letter_SOC_2.pdf",
		tooltipText:
			"Authenticate is voluntarily, independently certified as SOC 2 Type II compliant by an AICPA® accredited CPA. The full report is available upon request.",
		logo: Aicpa
	},
	{
		id: 2,
		name: "HIPPA",
		link: "https://cdn.authenticating.com/public/website/Authenticating+Certificate+of+Compliance+-+123122.pdf",
		tooltipText:
			"Authenticate has been voluntarily independently audited for compliance with HIPAA Security rule 45 CFR parts §164.308, §164.310, §164.312. Full report can be furnished upon request.",
		logo: HIPPA
	},

	{
		id: 3,
		name: "PCI",
		link: "https://docs-prv.pcisecuritystandards.org/PCI%20DSS/General%20Guidance/PCI-DSS-v4-0-At-A-Glance.pdf",
		tooltipText:
			"Authenticate has an Attestation of Compliance available upon request as well as a PCI DSS Self-Assessment Questionnaire.",
		logo: PCI
	},
	{
		id: 4,
		name: "Idpro",
		link: "https://www.credly.com/badges/d048b94b-f29a-4a91-a28b-d840127bccf5",
		tooltipText: false,
		logo: Idpro
	},
	{
		id: 5,
		name: "PBSA",
		link: "https://thepbsa.org/",
		tooltipText: false,
		logo: Pbsa
	}
];
